import React, { ReactElement } from 'react';
import * as css from './Footer.module.scss';
import { strings } from 'src/localization';
import SVPButton from '../SVPButtons/SVPButton';
import classNames from 'classnames';
import { ComponentMapIds } from '../map';
import { THEME } from 'src/constants/ThemeNames';

interface IProps {
    id: string;
    message?: string;
    handler: (event: any) => void;
    isDisabled?: boolean;
    secondaryMessage?: string;
    secondaryhandler: (event: any) => void;
    secondaryIsDisabled?: boolean;
    noButtons?: boolean;
    noArrow?: boolean;
    theme?: string;
    currentScreen?: string;
}

const Footer = (props: IProps) => {
    const isAudi = props.theme === THEME.AUDI;
    // Default the footer Css value.  Can change if we have second button.
    let footerCss = isAudi ? css.footerAudi : css.footer;
    // Default the second button to null but set it up to allow ReactElement as well.
    let secondaryBtn: ReactElement | null = null;

    const noArrow = props.theme === 'porsche' || props.theme === 'bmw' ? true : false;
    // if we have a seoncdary message, then change the footer CSS
    // to the double button footer css.  Build the second button.
    if (props.secondaryMessage) {
        footerCss = isAudi ? css.doubleBtnFooterAudi : css.doubleBtnFooter;
        let secndryToolTip = '';
        if (props.secondaryMessage === strings.NoImNew) {
            secndryToolTip = strings.ImNewTip;
        }
        if (props.secondaryMessage === strings.DifferentTime) {
            secndryToolTip = strings.AltTimeTip;
        }
        let noBtnArrow = false;
        if (props.secondaryMessage === strings.Cancel || noArrow) {
            noBtnArrow = true;
        }

        secondaryBtn =
            <div className={css.secondaryBtn}>
                <SVPButton
                    id='otherBtn'
                    message={props.secondaryMessage}
                    handler={props.secondaryhandler}
                    variant={'secondaryBtnAlt'}
                    noArrow={noBtnArrow}
                    isDisabled={props.secondaryIsDisabled}
                    tooltip={secndryToolTip}
                    theme={props.theme}
                />
            </div>;
    }

    // primary Message will defauilt to Proceed, but will use
    // passed in value if it exists.
    let primaryMsg = strings.Proceed;
    if (props.message) {
        primaryMsg = props.message;
    }
    let primaryToolTip = '';

    switch (primaryMsg) {
        case strings.YesIHave:
            primaryToolTip = strings.ExistingCustTip;
            break;
        case strings.Proceed:
            primaryToolTip = strings.ProceedTip;
            break;
        case strings.Skip:
            if (props.id === 'SvcTabFooter') {
                primaryToolTip = strings.SkipServcTip;
            } else if (props.id === 'AddSvcsFooter') {
                primaryToolTip = strings.SkipRecSvcsTip;
            }
            break;
        case strings.CreateAcct:
            if (props.id === 'ConfFooter') {
                primaryToolTip = strings.CreateAcctTip;
            }
            break;
        case strings.UpdateInfo:
            primaryToolTip = strings.ClickToUpdate;
            break;
        case strings.Save:
            primaryToolTip = strings.ClickToSave;
            break;
        case strings.AddAppt:
            primaryToolTip = strings.ClickToAdd;
            break;
        default:
            primaryToolTip = strings.ProceedTip;
    }

    if (props.isDisabled) {
        primaryToolTip = '';
    }

    let primaryBtn: ReactElement | null =
        <SVPButton
            id='proceedBtn'
            message={primaryMsg}
            handler={(event) => props.handler(event)}
            isDisabled={props.isDisabled}
            tooltip={primaryToolTip}
            theme={props.theme}
            noArrow={noArrow}
        />;
    if (props.noButtons) {
        primaryBtn = null;
    }

    const footerDivStyles = classNames(
        css.btnDiv,
        {
            [css.btnDivBMW]: props.theme === 'bmw',
            [css.btnDivAudi]: isAudi,
        },
    );

    const footerHrClass = classNames(
        css.footerHr,
        {
            [css.footerHrNoLine]: props.theme === 'honda' || props.theme === 'infiniti' ||
                (props.theme === 'nissan' && props.currentScreen === ComponentMapIds.Confirmation) ||
                (props.theme === 'mazda' && props.currentScreen === ComponentMapIds.Confirmation) ||
                (props.theme === 'acura' && props.currentScreen === ComponentMapIds.Confirmation) ||
                (props.theme === 'genesis' && props.currentScreen === ComponentMapIds.Confirmation) ||
                (props.theme === 'lexus' && props.currentScreen === ComponentMapIds.Confirmation),
        },
    );

    return (
        <div id={props.id} className={footerCss}>
            <hr className={footerHrClass}></hr>
            <div className={footerDivStyles}>
                {secondaryBtn}
                {primaryBtn}
            </div>
        </div >
    );
};

export default Footer;
